import React from 'react';
import { connect } from 'react-redux'

// import LoginEmail from './login-email'
import Login from './login'
import ConsentForm from './consent-form'

const AppComponent = ({authenticate, user, layout}) => {
  let content;
  if (authenticate === 'loading') {
    content = <div>Loading...</div>
  } else {
    if (authenticate) {
      content = <ConsentForm />
    } else {
      if (layout.route === 'LOGIN' && layout.tab === 'EMAIL') {
        content = <Login />
      }
    }
  }
  return (
    <div className="app">
      {content}
    </div>
  );
}

const mapStateToProps = state => {
  return {
    user: state.user,
    authenticate: state.authenticate,
    layout: state.layout,
  }
}

const App = connect(
  mapStateToProps,
)(AppComponent)

export default App


// WEBPACK FOOTER //
// ./src/containers/app.js